import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import PropTypes from 'prop-types';
import { Toaster } from 'sonner';

import { queryClient } from '../lib/queryClient.ts';

export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      {/* Toast en bottom-center para no tapar header en móvil, con offset para no cubrir contenido */}
      <Toaster 
        richColors 
        position="bottom-center"
        toastOptions={{
          style: {
            marginBottom: '1rem',
          },
        }}
        style={{
          bottom: '1rem',
        }}
      />
    </QueryClientProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
